import { FC } from 'react'
import LetterAscDescSort from './LetterAscDescSort'
import NumberAscDescSort from './NumberDescAscSort'

type Props = {
  selectedSort: string
  numbers: string[]
  isAsc: any
  setIsAsc: any
}

const AscDescSort: FC<Props> = (props) => {
  const { selectedSort, numbers, isAsc, setIsAsc } = props

  return (
    <span
      className="cursor-pointer ms-2"
      onClick={() => setIsAsc((prev: any) => !prev)}
    >
      {numbers.includes(selectedSort) ? (
        <NumberAscDescSort isAsc={isAsc} />
      ) : (
        <LetterAscDescSort isAsc={isAsc} />
      )}
    </span>
  )
}

export default AscDescSort
